import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Backpack } from 'lucide-react';
import { Toaster } from 'sonner';
import { RespuestaResumen } from './FormularioFamiliar';
import { DocumentacionAdmin } from './DocumentacionAdmin';

const API = process.env.REACT_APP_BACKEND_URL + '/api/actualizacion-familiar/admin/respuestas';

export const ActualizacionFamiliarPerfil = ({ trabajadorId }) => {
  const [respuesta, setRespuesta] = useState(undefined);

  useEffect(() => {
    if (!trabajadorId) return;
    axios.get(`${API}/${trabajadorId}`).then((r) => setRespuesta(r.data.respuesta)).catch(() => setRespuesta(null));
  }, [trabajadorId]);

  return (
    <div data-testid="perfil-actualizacion-familiar">
      <Toaster position="top-right" richColors />
      <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
        <Backpack className="w-5 h-5 text-primary" />
        Actualización Familiar 2027
      </h3>
      {respuesta === undefined && <p className="text-sm text-gray-400">Cargando…</p>}
      {respuesta === null && <p className="text-sm text-gray-400" data-testid="perfil-af-sin-respuesta">No completó el formulario.</p>}
      {respuesta && (
        <>
          <RespuestaResumen respuesta={respuesta} />
          <p className="text-xs text-gray-400 mt-2">
            Completado el {new Date(respuesta.completado_en).toLocaleDateString('es-AR')}
            {respuesta.editado_por && ` · editado por ${respuesta.editado_por}`}
          </p>
          <div className="mt-4 rounded-lg border bg-gray-50 p-4"><DocumentacionAdmin trabajadorId={trabajadorId} /></div>
        </>
      )}
    </div>
  );
};
